// extracted by mini-css-extract-plugin
export default {"button":"MidgetButton_button__e2tD8","loading":"MidgetButton_loading__sk0Qg","text":"MidgetButton_text__vgjNA","icon":"MidgetButton_icon__7F4o-"};